import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[500px] md:min-h-[620px] flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Playful%20golden%20retriever%20dog%20and%20orange%20tabby%20cat%20playing%20together%20with%20eco-friendly%20natural%20toys%20in%20a%20bright%20airy%20modern%20living%20room%20with%20plants%2C%20warm%20natural%20morning%20light%2C%20lifestyle%20pet%20photography%2C%20soft%20creamy%20background%2C%20happy%20energetic%20mood%2C%20premium%20editorial%20style%2C%20clean%20composition&width=1800&height=900&seq=pouncebounce-hero-01&orientation=landscape"
          alt="Dog and cat playing with eco-friendly PounceBounce toys"
          className="w-full h-full object-cover object-center"
        />
        {/* Dark overlay for text contrast */}
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/40 via-foreground-950/20 to-foreground-950/40"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-4 md:px-8 lg:px-12 text-center">
        <div className="max-w-3xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-background-50/10 backdrop-blur-sm rounded-full border border-background-50/20 mb-6 animate-fade-up" style={{ animationDelay: '0.1s' }}>
            <span className="w-2 h-2 bg-accent-500 rounded-full animate-pulse"></span>
            <span className="text-background-50 text-xs font-medium tracking-wide">New Collection Dropping</span>
          </div>

          <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading font-extrabold text-background-50 leading-tight mb-4 animate-fade-up" style={{ animationDelay: '0.25s' }}>
            Play Hard.
            <br />
            Tread Soft.
          </h1>

          <p className="text-base md:text-lg text-background-50/90 max-w-xl mx-auto mb-8 leading-relaxed animate-fade-up" style={{ animationDelay: '0.4s' }}>
            Premium pet toys &amp; accessories crafted from non-toxic, biodegradable, chew-safe materials — for the dog and cat parents who treat their pets as family.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 animate-fade-up" style={{ animationDelay: '0.55s' }}>
            <Link
              to="/shop"
              className="group inline-flex items-center gap-2 px-8 py-3.5 bg-accent-500 text-background-50 rounded-full font-bold text-sm md:text-base hover:bg-accent-600 transition-all duration-200 paw-bounce shadow-sm whitespace-nowrap"
            >
              Shop Now
              <i className="ri-arrow-right-line paw-icon transition-transform group-hover:translate-x-1"></i>
            </Link>
            <Link
              to="/about"
              className="inline-flex items-center gap-2 px-8 py-3.5 bg-background-50/10 backdrop-blur-sm text-background-50 rounded-full font-semibold text-sm md:text-base border border-background-50/20 hover:bg-background-50/20 transition-all duration-200 whitespace-nowrap"
            >
              Our Story
            </Link>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex flex-col items-center gap-1.5 text-background-50/70">
        <span className="text-[10px] uppercase tracking-widest font-medium">Scroll</span>
        <div className="w-5 h-8 rounded-full border border-background-50/30 flex items-start justify-center p-1">
          <div className="w-1.5 h-1.5 rounded-full bg-background-50/60 animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}